import { getPxAsRem } from 'shared/utils'
import Attributes from './Attributes/Attributes'
import Education from './Education'
import { Container } from './styled'

import type {
    GetCandidateProfileForRecruiterQuery,
    GetCandidateProfileForRecruiterQueryVariables,
} from '__generated__/graphql'
import type { FC } from 'react'
import type { ApolloQueryRefetchFunction } from 'shared/types/graphql'

interface BackgroundProps {
    data: GetCandidateProfileForRecruiterQuery
    refetch: ApolloQueryRefetchFunction<
        GetCandidateProfileForRecruiterQuery,
        GetCandidateProfileForRecruiterQueryVariables
    >
}

const Background: FC<BackgroundProps> = ({ data, refetch }) => {
    return (
        <Container container columnSpacing={getPxAsRem(24)} columns={12}>
            <Education data={data} refetch={refetch} />
            <Attributes refetch={refetch} />
        </Container>
    )
}

export default Background
